import { Swiper, Navigation, Pagination, Scrollbar, Autoplay } from "swiper/swiper.esm.js";
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);
// init Swiper:
const swiper = new Swiper();

const Lookbook = {
  init: function() {
    this.initLookbookSlider();
    if(window.innerWidth <= 768) {
      var swiper = new Swiper(".js-lb-slider-product", {
        slidesPerView: 2,
        spaceBetween: 5,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    }
  },

  initLookbookSlider: function() {
    var delay = $(".js-lookbook-slider").data('delay');
    var autoplay = $(".js-lookbook-slider").data('autoplay');
    var slider = new Swiper(".js-lookbook-slider", {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: autoplay ? delay : 99999999,
        disableOnInteraction: false,
      },
    });
  }
}

window.Lookbook = Lookbook;

$(function() {
  Lookbook.init();
})

export default Lookbook
